import type { SVGProps } from 'react';
export const Shop = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M5.13 3.5h9.75a1.2 1.2 0 0 1 1.15.87l.94 3.33.03.18v1.06a2.8 2.8 0 0 1-1.05 2.19v4.17a1.2 1.2 0 0 1-1.2 1.2h-9.5a1.2 1.2 0 0 1-1.2-1.2v-4.17A2.8 2.8 0 0 1 3 8.94V7.88q0-.09.03-.18l.94-3.33a1.2 1.2 0 0 1 1.15-.87m0 6.73L5 10.15a1.4 1.4 0 0 1-.65-1.21v-.39h2.87v.39q-.01.6-.43 1.03a1.4 1.4 0 0 1-1.65.26m.28 1.48v3.45h9.18V11.7a2.8 2.8 0 0 1-2.48-.94l-.14.14a2.8 2.8 0 0 1-4.08-.14 2.8 2.8 0 0 1-2.48.94m3.16-2.77q0 .6.42 1.03a1.4 1.4 0 0 0 2.02 0c.27-.27.42-.64.42-1.03v-.39H8.57zm6.86-1.73-.67-2.37H5.24l-.67 2.37zm.22 1.34h-2.87v.39q.01.6.43 1.03a1.4 1.4 0 0 0 1.65.26l.14-.08a1.4 1.4 0 0 0 .65-1.21z"
      clipRule="evenodd"
    />
  </svg>
);
